import type {} from "@lit/react";
import { Message as MessageElement, } from "@vaadin/message-list/vaadin-message.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { MessageElement, };
export type MessageEventMap = Readonly<{}>;
const events = {} as MessageEventMap;
export type MessageProps = WebComponentProps<MessageElement, MessageEventMap>;
export const Message = createComponent({
    elementClass: MessageElement, events, react: React, tagName: "vaadin-message"
});
